import React from "react";

function OrgListTable() {
  return <div>dsd</div>;
}

function OrgLists() {
  return (
    <div className=" flex flex-col gap-6 ">
      <div>
        <OrgListTable />
      </div>
    </div>
  );
}

export default OrgLists;
